import * as THREE from 'three';
import {cameraPersp} from './camera'
import add_renderer from "./renderer";
import {add_grid} from "./grid";

export const threeMain = function () {
    this.component = document.getElementById("debugThreejs");

    this.scene = new THREE.Scene();
    this.cameraPersp = new cameraPersp(this.component);

    this.grid = add_grid(2000, 100);
    this.grid.visible = true;
    this.scene.add(this.grid);
    this.renderer = add_renderer(this.component);
    const geometry = new THREE.PlaneBufferGeometry(100, 100, 4, 4);
    let material = new THREE.MeshBasicMaterial(
        {
            color: 0xFF0000,
            side: THREE.DoubleSide
        }
    );

    let plane = new THREE.Mesh(geometry, material);
    plane.rotateY(45);
    this.scene.add(plane);

    if (this.component)
        this.component.appendChild(this.renderer.domElement);
    this.renderer.render(this.scene, this.cameraPersp);
}
